import React, { useState, useEffect } from "react";
import { Switch, Route, useParams, Redirect } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { createMuiTheme, ThemeProvider } from "@material-ui/core";

// State Management
import { selectUser } from "../store/reducers/userSlice";
import { login, logout } from "../store/reducers/userSlice";
import {
  characterLogout,
  setActiveCharacter,
  setCharacter,
} from "../store/reducers/characterSlice";
import { channelLogout } from "../store/reducers/appSlice";
import {
  setRoominvitation,
  unsetRoominvitation,
} from "../store/reducers/roominvitationSlice";

// DB
import db, { auth } from "../firebase/firebase";

// Components
import Home from "./Home/Home";
import Welcome from "./Welcome/Welcome";
import Login from "./Login/Login";
import classes from "./App.module.css";
import Loader from "../hooks/IsLoading/Loader/Loader";
import RoominvitationService from "../services/RoominvitationService";

const theme = createMuiTheme({
  palette: {
    type: 'dark',
    primary: {
      main: '#ffffff',
      dark: '#4f5660',
    },
    secondary: {
      main: '#ffcc4d',
    },
    background: {
      default: '#202225',
      paper: '#4f5660',
    },
    error: {
      main: '#e60808',
    },
    info: {
      main: '#5ff3ef',
    },
  },

  overrides: {
    //scrollbar override to make more visibile
    MuiOutlinedInput: {
      root: {
        width: '252px',
      }
    },
    MuiCssBaseline: {
      '@global': {
        '*::-webkit-scrollbar-thumb': {
          backgroundColor: 'white',
          // outline: '3px solid white'
        },
        '*': {
          'scrollbar-width': 'thin',
        },
        '*::-webkit-scrollbar': {
          width: '4px',
          height: '4px',
        }
      }
    },
    MUIRichTextEditor: {
      primary: {
        color: 'white'
      },
      backgroundColor: '#222',
      root: {
      },
      container: {
        marginTop: '5px',
      },
      toolbar: {
        color: "white",
        textAlign: 'left',
        // display: 'grid',                            
        // gridTemplateColumns: 'repeat(5, 30px)',   
        // gridAutoRows: '30px',                     
        // grid-gap: 10px;                           

      },
      editor: {
        marginRight: '5px',
        marginLeft: '5px',
        overflow: 'auto'

      },
    }
  }
});




function App() {
  const dispatch = useDispatch();
  const user = useSelector(selectUser);
  const [loading, setLoading] = useState(true);
  const [newUser, setNewUser] = useState(true);

  // Handle Auth
  useEffect(() => {
    auth.onAuthStateChanged((authUser) => {
      if (authUser) {
        dispatch(
          login({
            uid: authUser.uid,
            photo: authUser.photoURL,
            email: authUser.email,
            displayName: authUser.displayName,
          })
        );

        // Check if user exists in db or not?
        let docRef = db.collection("users").doc(authUser.uid);
        docRef
          .onSnapshot((docSnapshot) => {
            if (docSnapshot.exists) {
              // If user exists proceed to app
              setNewUser(false);

              docRef
                .collection("characters")
                .doc(docSnapshot.data().id)
                .onSnapshot((snapshot) => {
                  if (snapshot.exists) {
                    dispatch(setActiveCharacter(docSnapshot.data().id));
                    dispatch(setCharacter(snapshot.data()));
                  }
                });



              setLoading(false);
            }
            setLoading(false);
          });
      } else {
        // the user is logged out
        setLoading(false);
        dispatch(logout());
        dispatch(characterLogout());
        dispatch(channelLogout());
      }
      // return () => {
      //   unsubscribe();
      // };
    });
  }, [dispatch]);

  function RoomInvitation() {
    let { invitationId } = useParams();
    if (invitationId) {
      let roomInvitationService = new RoominvitationService();
      roomInvitationService
        .getInvitationByUid(invitationId)
        .then(function (invitationData) {
          dispatch(
            setRoominvitation({
              id: invitationData.id,
              uid: invitationData.uid,
              channelId: invitationData.channelId,
              isValid: invitationData.isValid,
            })
          );
        });
    } else {
      dispatch(unsetRoominvitation());
    }
    return <Redirect to="/" />;
  }

  let routes = "";
  if (user) {
    routes = (
      <Switch>
        <Route path={["/invite/:invitationId"]}>
          <RoomInvitation />
        </Route>

        <Route path={["/home", "/", ""]}>
          {newUser ? <Welcome /> : <Home />}

        </Route>
      </Switch>
    );
  }

  if (!user) {
    routes = <Login />;
  }

  if (loading) {
    routes = <Loader />;
  }

  return (
    <ThemeProvider theme={theme}>
      <div className={classes.App}>{routes}</div>{" "}
    </ThemeProvider>
  );
}

export default App;
